module.exports = __webpack_public_path__ + "media/images/illustrations/403-error-forbidden-4cc7a0e21bc51d84c15e28782c2012f7.svg";